<template>

    <div class="panel-body mt-4">
        <div class="panel-tag">
            Інструкції ІМК
        </div>
        
        <div class="instructions mt-4">
            <ul class="list-group">
                <li class="list-group-item" :key="item.id" v-for="item in items">
                    <a class="instruction" href="#" v-on:click.prevent.stop="show_item(item)">
                        <i class="fal fa-code-merge width-2 fs-xl"></i>
                        {{item.title}}
                    </a>
                </li>
            </ul>
        </div>
        <instruction_modal></instruction_modal>
    </div>
  
</template>

<script>

import Instruction_modal from "./modal/instruction_modal.vue";

export default {
    components : {
        Instruction_modal
        
    },
    name: "instructions",
    data() {
        return {
            items  : [],
            is_show : false,
        }
    },
    
    created() {
        this.getItems();
    },
    
    mounted() {
    
    },
    
    
    methods: {
        show_item(article) {
            EventBus.$emit('show_instruction',article);
        },
        
        async getItems() {
            this.is_show = true;
            await axios.get('/internal/user.instructions').then(({data}) => {
                this.is_show = false;
                if (data.status == "operation_success") {
                    this.items = data.data;
                }
            }).catch(err => {
                this.is_show = false;
                EventBus.$emit('show_toast', {err:err.message ,type:"danger",title:err.name})
            });
        },
    },
    computed: {
    
    },
}
</script>

<style scoped>

</style>